import React, { useMemo } from "react";
import Slider from "@mui/material/Slider";

export default function RangeSelector({
  value,
  onChange,
  intervalSeconds,
  durationSeconds,
  label,
}) {
  const maxDuration = durationSeconds || 0;
  const windowSize = intervalSeconds || 0;

  const safeValue = useMemo(() => {
    if (Array.isArray(value) && value.length === 2) {
      return value;
    }
    if (windowSize > 0) {
      return [0, Math.min(windowSize, maxDuration)];
    }
    return [0, maxDuration];
  }, [value, windowSize, maxDuration]);

  const handleChange = (_event, newValue) => {
    if (!Array.isArray(newValue)) return;

    let [rawA, rawB] = newValue;
    let start = Math.min(rawA, rawB);

    let size = windowSize || Math.max(0, safeValue[1] - safeValue[0]);
    if (size <= 0) {
      size = maxDuration;
    }
    let end = start + size;
    if (end > maxDuration) {
      end = maxDuration;
      start = Math.max(0, end - size);
    }

    onChange?.([start, end]);
  };

  const step = intervalSeconds && intervalSeconds > 0 ? intervalSeconds : 1;
  const disabled = !intervalSeconds || intervalSeconds <= 0;

  return (
    <div className="tw-mt-4">
      {!disabled && (
        <Slider
          value={safeValue}
          min={0}
          max={maxDuration}
          step={step}
          onChange={handleChange}
          disableSwap
          valueLabelDisplay="off"
        />
      )}

      <div className="tw-mt-2 tw-inline-flex tw-rounded-md tw-bg-slate-100 tw-px-3 tw-py-1 tw-text-[11px] tw-text-slate-700">
        {disabled ? "" : label}
      </div>
    </div>
  );
}
